import { DetalhesLotesManualModule } from './pages/detalhes-lotes-manual/detalhes-lotes-manual.module';
import { DetalhesLotesManualV2Module } from './pages/detalhes-lotes-manual-v2/detalhes-lotes-manual-v2.module';
import { forwardRef, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from './core/core.module';
import {
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule
} from '@angular/forms';
import { CurrencyPipe, DatePipe, PercentPipe, registerLocaleData, TitleCasePipe } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { provideNgxMask } from 'ngx-mask';
import { AprovacaoResumoComponent } from './pages/aprovacao-resumo/aprovacao-resumo.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { InterceptorModule } from './services/interceptor.module';
import { ModalEmailComponent } from './pages/configuracoes/configuracoes-email/modal-email/modal-email.component';
import { DetalhesLotesModule } from './pages/detalhes-lotes/detalhes-lotes.module';
import { OAuthModule } from 'angular-oauth2-oidc';
import { ClipboardModule } from 'ngx-clipboard';

registerLocaleData(localePt);

@NgModule({ declarations: [AppComponent, AprovacaoResumoComponent, ModalEmailComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        SharedModule,
        BrowserAnimationsModule,
        CoreModule,
        ReactiveFormsModule,
        FormsModule,
        InterceptorModule,
        DetalhesLotesModule,
        DetalhesLotesManualModule,
        DetalhesLotesManualV2Module,
        OAuthModule.forRoot(),
        ClipboardModule], providers: [
        DatePipe,
        CurrencyPipe,
        TitleCasePipe,
        PercentPipe,
        {
            provide: LOCALE_ID,
            useValue: 'pt-BR'
        },
        provideHttpClient(withInterceptorsFromDi()),
        provideNgxMask()
    ] })
export class AppModule {}
